<template>
    <!-- <input type="checkbox" id="e2-menu-checkbox" /> -->
    <label for="e2-menu-checkbox" class="btn e2-btn ms-3 e2-menu-bg" :style="sidebarStatus ? 'display: block;' : 'display: none;'" @click="sidebarStatus = !sidebarStatus"></label>
    <div class="e2-menu" :style="sidebarStatus ? 'display: block;' : 'display: none;'">
        <label for="e2-menu-checkbox" class="btn e2-btn ms-3 e2-menu-close" @click="sidebarStatus = !sidebarStatus"></label>
        <div class="e2-menu-list">
            <router-link :to="{name: 'index'}" class="text-decoration-none">
                <h2>{{G.pageTitle}}</h2>
            </router-link>
            <ul class="menu-ul">
                <li v-for="(item, index) in menus" :key="index" :class="$route.name.match(item.link) ? 'menu-active' : ''">
                    <router-link
                        v-if="!item.link.match(/^#/i)"
                        :to="{name: item.link, params: {lang: def_lang}}"
                    >{{item.name}}</router-link>
                    <!-- <template
                        v-if="!item.link.match(/^#/i)"
                    ><a :href="`${def_lang}/${item.link}`">{{item.name}}</a></template>-->
                    <template v-else>
                        <a :href="item.link">{{item.name}}</a>
                    </template>
                </li>
            </ul>
        </div>
        <div class="e2-menu-info"></div>
    </div>
    <nav class="navbar e2-navbar fixed-top" id="navbar" style="width: fit-content; left: auto;">
        <div class="d-block">
            <label class="e2-nav-button float-end" for="e2-menu-checkbox" @click="sidebarStatus = !sidebarStatus">
                <span class="navbar-toggler-icon"></span>
            </label>
            <button
                class="e2-nav-button float-end"
                type="button"
                id="lang_menu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                v-if="languages.length > 1"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    width="512"
                    height="512"
                    x="0"
                    y="0"
                    viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512"
                    xml:space="preserve"
                    fill="#000000"
                >
                    <g>
                        <g
                            xmlns="http://www.w3.org/2000/svg"
                            id="_x35_11_x2C__Global_x2C__Globe_x2C__Internet"
                            fill="#000000"
                        >
                            <path
                                d="m256 6c-138.021 0-250 111.98-250 250s111.979 250 250 250c138.02 0 250-111.979 250-250s-111.98-250-250-250zm180.424 392.633c-22.507-13.043-47.881-22.603-73.141-29.25 7.614-31.761 11.947-66.887 12.617-103.383h109.879c-2.103 48.273-19.388 94.754-49.355 132.633zm-360.847 0c-29.967-37.879-47.252-84.36-49.356-132.633h109.879c.67 36.496 5.003 71.622 12.617 103.383-25.446 6.819-50.169 15.92-73.14 29.25zm-.001-285.266c22.427 12.976 47.584 22.52 73.141 29.251-7.615 31.76-11.947 66.886-12.617 103.382h-109.879c2.104-48.274 19.389-94.754 49.355-132.633zm190.424 242.754v-90.121h89.898c-.664 34.999-4.807 68.575-12.067 98.813-23.761-4.95-50.192-8.076-77.831-8.692zm-97.831 8.692c-7.26-30.237-11.404-63.814-12.067-98.813h89.898v90.121c-27.307.609-53.566 3.645-77.831 8.692zm77.831-208.934v90.121h-89.898c.663-34.999 4.807-68.575 12.067-98.812 24.353 5.044 50.306 8.077 77.831 8.691zm20 90.121v-90.121c26.884-.6 53.011-3.542 77.831-8.691 7.261 30.237 11.403 63.813 12.067 98.812zm0-110.126v-108.607c21.479 5.362 42.433 27.722 58.691 63.194 5.281 11.522 9.935 24.061 13.938 37.406-23.94 4.882-48.499 7.464-72.629 8.007zm-20-108.607v108.607c-24.646-.555-49.21-3.227-72.629-8.007 4.003-13.345 8.657-25.884 13.938-37.406 16.258-35.473 37.211-57.833 58.691-63.194zm0 348.859v108.607c-21.48-5.362-42.433-27.722-58.691-63.194-5.281-11.522-9.935-24.061-13.938-37.406 23.561-4.783 47.859-7.449 72.629-8.007zm20 108.607v-108.607c25.926.583 50.03 3.416 72.629 8.007-4.003 13.346-8.656 25.884-13.938 37.406-16.258 35.473-37.212 57.832-58.691 63.194zm109.9-238.733c-.67-36.496-5.003-71.622-12.617-103.382 25.307-6.699 50.592-16.172 73.141-29.251 29.967 37.879 47.252 84.359 49.355 132.633zm47.166-148.059c-20.134 11.223-42.371 19.449-64.933 25.39-9.359-31.64-24.537-66.811-47.328-90.703 42.611 10.446 81.633 32.943 112.261 65.313zm-221.873-65.313c-22.791 23.892-37.968 59.064-47.327 90.703-22.45-5.908-44.646-14.099-64.933-25.39 30.63-32.37 69.65-54.867 112.26-65.313zm-112.259 381.431c20.424-11.347 42.508-19.513 64.933-25.39 9.359 31.637 24.536 66.812 47.327 90.702-42.612-10.445-81.631-32.942-112.26-65.312zm221.872 65.313c22.764-23.863 37.95-59.002 47.328-90.703 22.172 5.818 44.581 14.061 64.933 25.39-30.629 32.37-69.65 54.867-112.261 65.313z"
                                fill="rgba(0, 0, 0, 1)"
                                data-original="#000000"
                                class="lang_svg"
                            />
                        </g>
                    </g>
                </svg>
            </button>
            <ul class="dropdown-menu" aria-labelledby="lang_menu" v-if="languages.length > 1">
                <li v-for="(item, index) in languages" :key="index">
                    <router-link
                        :to="{name: 'index', params:{lang: item.short_name}}"
                        class="dropdown-item"
                    >{{item.name}}</router-link>
                </li>
            </ul>
            <ul class="e2-navbar-list" id="e2-second-menu">
                <li v-for="(item, index) in menus" :key="index" :class="$route.name.match(item.link) ? 'menu-active' : ''">
                    <router-link
                        v-if="!item.link.match(/^#/i)"
                        :to="{name: item.link, params: {lang: def_lang}}"
                    >{{item.name}}</router-link>
                    <template v-else>
                        <a :href="item.link">{{item.name}}</a>
                    </template>
                </li>
            </ul>
            <div class="navbar-brand d-none d-sm-block">
                <router-link :to="{name: 'index'}">{{G.pageTitle}}</router-link>
            </div>
        </div>
    </nav>
</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";
    import { useStore } from "vuex";
    import { useRoute } from "vue-router";

    import { G, ajax } from "@/_common";

    export default {
        name: 'Navbar',
        props: {
            menus: {
                type: Array,
            },
        },
        setup() {
            const store = useStore();
            const route = useRoute();

            const languages = ref([]);
            const sidebarStatus = ref(false);

            // const def_lang = store.getters.getLang();
            const def_lang =
                route.params && route.params.lang ? route.params.lang : "az";

            const TR = ref({});

            watchEffect(() => {
                TR.value = store.getters.getTranslations();
            });

            onMounted(async () => {
                await ajax
                    .get(store.getters.getLanguagesLink())
                    .then((e) => {
                        if (e && e.data && e.data.length) {
                            languages.value = e.data;
                        }
                    })
                    .catch((error) => {
                        // var res = error.response || {};
                    });
            });

            return { G, TR, languages, def_lang, sidebarStatus };
        },
    };
</script>


<style lang="scss" >
    .menu-active{
        background-color: rgba(12,36,51,.8);
        color: #ffffff !important;
    }
    .menu-active a{
        color: #ffffff !important;
    }
    ul.e2-navbar-list {
        background: #ffffffe6;
    }
    .lang_svg {
        // color: rgba(0, 0, 0, 1) !important;
        fill: rgba(0, 0, 0, 1) !important;
    }
    .e2-menu-close, .e2-menu-bg {
        display: block;
    }
    .e2-menu {
        right: 0px;
    }

    .e2-menu ul > li {
        padding: 0px;
    }
    ul.menu-ul li a, ul.e2-navbar-list li a{
        display: block;
    }
</style>